import { createClientComponentClient } from './clientComponentClient';

export const createPagesBrowserClient = createClientComponentClient;
